import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const FuelHistoryDetailDashboard = lazyLoader(
  () =>
    import(
      "Containers/FuelHistory/FuelHIstoryDetail/FuelHistoryDetailDashboard"
    )
);

export const FuelHistoryDetail = () => {
  return (
    <Layout>
      <FuelHistoryDetailDashboard />
    </Layout>
  );
};
